<div class="col-12 text-center mb-3 p-0">
  <h3 class="fs-3 text-center">{{ 'geomarker.title_user_reviews_and_ratings' | translate }}</h3>
</div>

@let localValorations = valorations();
@let localResultValuations = resultValuations();
@let localUser = user();

<div class="col-12 p-0">
  <div class="row">
    <div class="col-12 col-md-7 col-xl-8 pe-3 mb-4 mb-md-0">
      <app-valoration-detail-comment
        [authenticated]="authenticated()"
        [marker]="marker() || 0"
        [city]="city() || 0"
        [user]="localUser?.id || 0"
        (commentDone)="getValuations()"
        (openAuthFormChange)="openAuthForm()"
      />
      <hr />

      @if (localValorations?.length) {
        <div class="d-flex flex-column">
          @for (valoration of localValorations; track valoration.id) {
            <app-valoration-detail-item
              [valorationDetail]="valoration"
              (valuationsChange)="getValuations('', true)"
            />
            <hr />
          }
        </div>

        @let localValuations = valuations();
        @if (
          localValuations > 3 ||
          ((localResultValuations?.count || 0) > 3 &&
            (localValorations?.length || 0) < (localResultValuations?.count || 0))
        ) {
          <button
            class="btn-valuations d-flex align-items-center gap-2 dark-blue-border px-4 w-fit-content rounded-4"
            [disabled]="requestValuations()"
            (click)="showMoreValuations()"
          >
            {{
              (localValuations === localValorations?.length ? '$ver_menos' : '$ver_mas') | translate
            }}
            <i
              class="inm-icon-arrow-bottom"
              [class.rotate]="localValuations === localValorations?.length"
            ></i>
          </button>
        }
      } @else {
        <div class="notifications-content text-center empty px-5">
          <img
            class="mt-3"
            lazyLoad="img/icons/valoration_icon-empty.png"
            height="80"
            alt="valoration_icon-empty"
          />
          <h3 class="mb-0 mt-4">
            {{ 'this_site_not_have_califications' | translate }}
          </h3>
          <p>{{ 'share_ur_experience' | translate }}</p>
        </div>
      }
    </div>

    <div class="col-12 col-md-5 col-xl-4 ps-3 item-data">
      <app-valoration-card
        [marker]="marker()"
        [city]="city()"
        [(userQualification)]="userQualification"
        [valuations]="localResultValuations?.count || 0"
        [hasQualification]="hasQualification()"
        (editCalificationChange)="editCalification()"
      />
    </div>
  </div>
</div>
